import { ToastContainer } from "react-toastify";
import Router from "./Router/Router";

import "./assets/css/theme.css";
import "./assets/css/style.scss";
import "./assets/css/main.scss";
import "./assets/css/table.scss";
import "react-toastify/dist/ReactToastify.css";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./assets/fonts/fonts.css"

export default function App() {
  return (
    <div className="App">
      <Router />
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}
